<script>

import {useVisibility} from "@/composables/useVisibility.js";

export default {

    props: {
        user: {
            type: Object,
            default: () => ({ companies_ids: [] })

        }
    },
    setup() {
        const {showTax, showAutoSettlement} = useVisibility()

        return {
            showTax,
            showAutoSettlement
        }
    },


    data() {
        return {
            errors: {},
            loading: false,
            loadingCompanies: false,
            companies: [],
            selectedCompanies: this.user.companies_ids ? this.user.companies_ids.map(id => ({ id })) : [],
            controller: {
                submit: null,
                load: null
            },

        }
    },
    methods: {
        submit() {
            this.loading = true;
            this.controller.submit = new AbortController();
            let request;
            let data = {
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                email: this.user.email,
                phone_number: this.user.phone_number,
                pesel: this.user.pesel,
                auto_settlement: this.user.auto_settlement,
                tax_active: this.user.tax_active,
                tax_rate: this.user.tax_rate ? this.user.tax_rate : 0,
                companies_ids: this.selectedCompanies.map(c => c.id),
            }
            if (this.user.id) {
                request = axios.put('/users/employees/' + this.user.id, data, {
                    signal: this.controller.submit.signal
                })
            } else {
                request = axios.post('/users/employees', data, {
                    signal: this.controller.submit.signal
                })
            }
            request.then((response) => {
                if (this.user.id) {
                    this.$toast.success(this.$t('employees.messages.account_updated'));
                } else {
                    this.$toast.success(this.$t('employees.messages.account_created'));
                }
                this.$router.push({name: 'employees.index'});
            }).catch((data) => {
                this.errors = data.response?.data?.errors || {};
            }).finally(() => {
                this.loading = false;
            })
        },
        loadCompanies() {
            if (this.controller.load) {
                this.controller.load.abort();
            }
            this.controller.load = new AbortController();
            this.loadingCompanies = true;
            axios.get('/companies',{
                signal: this.controller.load.signal
            }).then(response => {
                this.companies = response.data.data;
            }).catch(error => {
            }).finally(() => {
                this.loadingCompanies = false;
            })
        },
        addCompany() {
            const usedIds = this.selectedCompanies.map(c => c.id);
            const availableCompany = this.companies.find(c => !usedIds.includes(c.id));
            if (availableCompany) {
                this.selectedCompanies.push({ id: availableCompany.id });
            }
        },
        removeCompany(index) {
            this.selectedCompanies.splice(index, 1);
        }

    },
    mounted() {
        if (this.$auth.isAdmin()) {
            this.loadCompanies();
        }
    },
    beforeUnmount() {
        if (this.controller.submit) {
            this.controller.submit.abort();
        }
        if (this.controller.load) {
            this.controller.load.abort();
        }
    }
}

</script>
<template>
    <div class="employees-create">

        <form @submit.prevent="submit">

            <section class="block">

                <b-field :label="$t('users.fields.first_name.name')" custom-class="mb-3"
                         :type="errors.first_name ? 'is-danger' : null"
                         :message="errors.first_name ? errors.first_name[0] : null">
                    <b-input required
                             v-model="user.first_name"
                             icon="account"
                    />
                </b-field>

                <b-field :label="$t('users.fields.last_name.name')" custom-class="mb-3"
                         :type="errors.last_name ? 'is-danger' : null"
                         :message="errors.last_name ? errors.last_name[0] : null">
                    <b-input required
                             v-model="user.last_name"
                             icon="account"
                    />
                </b-field>

                <b-field :label="$t('users.fields.email.name')" custom-class="mb-3"
                         :type="errors.email ? 'is-danger' : null"
                         :message="errors.email ? errors.email[0] : null">
                    <b-input required
                             type="email"
                             v-model="user.email"
                             icon="at"
                    />
                </b-field>

                <b-field :label="$t('users.fields.phone_number.name')" custom-class="mb-3"
                         :type="errors.phone_number ? 'is-danger' : null"
                         :message="errors.phone_number ? errors.phone_number[0] : null">
                    <b-input v-model="user.phone_number" icon="phone"
                    />
                </b-field>

                <b-field :label="$t('users.fields.pesel.name')" custom-class="mb-3"
                         :type="errors.pesel ? 'is-danger' : null"
                         :message="errors.pesel ? errors.pesel[0] : null">
                    <b-input
                        required
                        maxlength="15"
                        v-model="user.pesel"
                        icon="card-account-details-outline"
                    />
                </b-field>


                <b-field custom-class="mb-3" v-if="$auth.isAdmin()"
                         :type="errors.companies_ids ? 'is-danger' : null" label="Firmy"
                         :message="errors.companies_ids ? errors.companies_ids[0] : null">

                    <div v-for="(row, index) in selectedCompanies" :key="index" class="is-flex mb-2" style="gap: 0.5rem;">
                        <b-select
                            expanded
                            v-model="row.id"
                            icon="domain"
                            :loading="loadingCompanies">
                            <option v-for="company in companies" :key="company.id" :value="company.id">
                                {{ company.name }}
                            </option>
                        </b-select>
                        <b-button type="is-danger" icon-left="close" @click="removeCompany(index)" />
                    </div>

                </b-field>

                <b-field class="checkbox-wrapper mb-3" v-if="$auth.isAdmin()">
                    <div class="mb-4">
                        <b-button
                            type="is-primary"
                            icon-left="plus"
                            :disabled="selectedCompanies.length >= companies.length"
                            @click="addCompany">
                            Dodaj firmę
                        </b-button>
                    </div>
                </b-field>

                <b-field class="checkbox-wrapper mb-3" v-if="showAutoSettlement">

                    <b-checkbox v-model="user.auto_settlement"
                                input-id="auto_settlement"
                                true-value="1"
                                false-value="0">
                    </b-checkbox>
                    <label for="auto_settlement" class="label">{{ $t('users.fields.auto_settlement.name') }}</label>
                </b-field>

                <b-field class="checkbox-wrapper mb-3" v-if="showTax">
                    <b-checkbox v-model="user.tax_active"
                                input-id="tax_active"
                                true-value="1"
                                false-value="0">
                    </b-checkbox>
                    <label for="tax_active" class="label">{{ $t('users.fields.tax_active.name') }}</label>
                </b-field>

                <b-field :label="$t('users.fields.tax_rate.name')" custom-class="mb-3" v-if="showTax"
                         label-for="tax_rate"
                         :type="errors.tax_rate ? 'is-danger' : null"
                         :message="errors.tax_rate ? errors.tax_rate[0] : null">
                    <b-input
                        type="number"
                        min="0"
                        max="100"
                        :disabled="user.tax_active == 0"
                        v-model="user.tax_rate"
                        icon="bank"
                    />
                </b-field>

            </section>

            <section class="buttons">
                <b-button type="is-primary" native-type="submit" :loading="loading">
                    {{ $t('actions.save') }}
                </b-button>
                <b-button @click.prevent="$router.push({name: 'employees.index'})">
                    {{ $t('actions.back') }}
                </b-button>
            </section>

        </form>
    </div>
</template>
